/**
 * Takes a timestamp as parameter and returns his end time.
 *
 * @param   {?number} timestamp or Date.now() timestamp value by default
 *
 * @returns {number} end time timestamp
 */
function getEndTime(timestamp = new Date()) {
    const date = new Date(timestamp)

    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59,
        59,
    ).getTime()
}

export default getEndTime
